import { createContext, useContext, useState } from "react";

const ModalContext = createContext(null);

export const ModalProvider = ({ children }) => {
  const [waitlistOpen, setWaitlistOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <ModalContext.Provider
      value={{
        waitlistOpen,
        contactOpen,
        openWaitlist: () => setWaitlistOpen(true),
        openContact: () => setContactOpen(true),
        setWaitlistOpen,
        setContactOpen,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
